import { DNABox, DNAChip, DNAText, Icon, Iffy } from '@alucio/lux-ui';
import React from 'react';
import { StyleSheet } from 'react-native';
import useRecording, { RecordingStatus } from '../../../hooks/useIsRecording';
const styles = StyleSheet.create({
    icon: {
        width: 22,
        height: 22,
        color: '#CB3831',
        marginLeft: 8,
    },
    container: {
        backgroundColor: '#FFFFFF',
        borderRadius: 4,
        height: 32,
        minWidth: 96,
        marginTop: 6,
        marginBottom: 6,
    },
    text: {
        marginLeft: 6,
    },
});
export var DNARecordingBadgeMode;
(function (DNARecordingBadgeMode) {
    DNARecordingBadgeMode["RECORDING"] = "Recording";
    DNARecordingBadgeMode["PREPARING"] = "Preparing";
})(DNARecordingBadgeMode || (DNARecordingBadgeMode = {}));
export function DNARecordingMobileBadge() {
    const { isRecording: recordingStatus, } = useRecording({ isHost: false });
    return (React.createElement(Iffy, { is: [RecordingStatus.RECORDING, RecordingStatus.RECORDER_RESUMED].includes(recordingStatus) },
        React.createElement(DNAChip, { appearance: "tag", style: {
                width: 34,
                marginLeft: '1vw',
                marginTop: '1vh',
                position: 'absolute',
                borderRadius: 8,
                zIndex: 100,
            }, status: "danger" }, "REC")));
}
export default function DNARecordingBadge(props) {
    const { mode } = props;
    const text = mode === DNARecordingBadgeMode.PREPARING ? 'Preparing to record' : 'Recording';
    const color = mode === DNARecordingBadgeMode.PREPARING ? '#B6B6B6' : '#CB3831';
    const fixedWidth = mode === DNARecordingBadgeMode.PREPARING ? 190 : 115;
    return (React.createElement(DNABox, { alignY: "center", appearance: "row", style: [styles.container, { width: fixedWidth }], alignX: "start" },
        React.createElement(Icon, { name: 'record', style: [styles.icon, { color: color }] }),
        React.createElement(DNAText, { style: styles.text }, text)));
}
//# sourceMappingURL=DNARecordingBadge.js.map